<template>
  <b-modal
    :can-cancel="['escape', 'x', 'outside']"
    :active="displayModal"
    @close="closeForm"
    has-modal-card
    :width="1000"
  >
    <div class="modal-card" style="width: 1000px">
      <form @submit.prevent="validateBeforeSubmit">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ modalTitle }}</p>
        </header>
        <section class="modal-card-body">
          <b-notification :closable="false">
            {{ $t('compCarbonFormsBuildingsModal.info-1') }}
            <br />
            <br />
            <div class="columns">
              <div class="column">
                <b-field
                  v-if="allBuildings.length === 0"
                  :label="$t('id')"
                  :type="{ 'is-danger': errors.has('id') }"
                  :message="errors.first('id')"
                >
                  <b-input
                    name="id"
                    icon="building"
                    :disabled="isSubmitted"
                    v-validate="'required|uniqueID'"
                    maxlength="50"
                    v-model="cbuilding.name"
                  ></b-input>
                </b-field>
                <b-field
                  v-else
                  :label="$t('id')"
                  :type="{ 'is-danger': errors.has('id') }"
                  :message="errors.first('id')"
                >
                  <b-autocomplete
                    name="id"
                    icon="building"
                    v-model="cbuilding.name"
                    :disabled="isSubmitted"
                    :open-on-focus="true"
                    :data="allBuildings"
                    v-validate="'required|uniqueID'"
                    field="name"
                    @typing="reset"
                    @select="(option) => selectBuilding(option)"
                  >
                  </b-autocomplete>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field
                  :label="$t('compCarbonFormsBuildingsModal.field-10')"
                  :type="{ 'is-danger': errors.has('constructionYear') }"
                  :message="errors.first('constructionYear')"
                >
                  <template #label>
                    {{ $t('compCarbonFormsBuildingsModal.field-10') }}
                    <b-tooltip
                      multilined
                      :label="$t('compCarbonFormsBuildingsModal.tooltip-4')"
                      type="is-black"
                    >
                      <b-icon icon="info-circle" />
                    </b-tooltip>
                  </template>
                  <b-input
                    name="constructionYear"
                    placeholder="1980"
                    :disabled="ghgiStore.item.isSubmitted"
                    v-validate="'required|numeric|min_value:1000'"
                    v-model="cbuilding.constructionYear"
                  />
                </b-field>
              </div>
              <div class="column">
                <b-field
                  :label="$t('compCarbonFormsBuildingsModal.field-8')"
                  :type="{ 'is-danger': errors.has('area') }"
                  :message="errors.first('area')"
                >
                  <b-input
                    name="area"
                    :disabled="ghgiStore.item.isSubmitted"
                    v-validate="'required|numeric|min_value:1'"
                    v-model="cbuilding.area"
                  />
                </b-field>
              </div>
              <div class="column">
                <l-field
                  :label="$t('compCarbonFormsBuildingsModal.field-9')"
                  :type="{ 'is-danger': errors.has('share') }"
                  :tooltip="$t('compCarbonFormsBuildingsModal.field-9-tooltip')"
                  :message="errors.first('share')"
                >
                  <b-input
                    name="share"
                    :disabled="isSubmitted"
                    v-validate="
                      'required|decimal:2|max_value:100|min_value:0.01'
                    "
                    v-model="cbuilding.share"
                  />
                </l-field>
              </div>
            </div>
          </b-notification>

          <b-notification v-if="authStore.isAuthenticated" :closable="false">
            <tags-input v-model="cbuilding.tags" :disabled="isSubmitted" />
          </b-notification>

          <b-notification :closable="false">
            <div v-html="$t('compCarbonFormsBuildingsModal.info-2')"></div>
          </b-notification>

          <m-tabs
            multiline
            v-model="activeTab"
            class="block"
            style="margin: auto !important"
          >
            <m-tab-item icon="plug" :label="$t('electricity')">
              <b-notification :closable="false">
                <b-checkbox
                  :disabled="ghgiStore.item.isSubmitted"
                  v-model="cbuilding.selfProduction"
                >
                  {{ $t('compCarbonFormsBuildingsModal.check-1') }}
                  <b-tooltip
                    multilined
                    :label="$t('compCarbonFormsBuildingsModal.tooltip-1')"
                    type="is-black"
                  >
                    <b-icon icon="info-circle" />
                  </b-tooltip>
                </b-checkbox>
                <br v-if="cbuilding.selfProduction" />
                <br v-if="cbuilding.selfProduction" />
                <b-field
                  v-show="cbuilding.selfProduction"
                  :label="$t('compCarbonFormsBuildingsModal.field-5')"
                  :type="{ 'is-danger': errors.has('selfConsumption') }"
                  :message="errors.first('selfConsumption')"
                  style="margin-bottom: 25px !important"
                >
                  <b-input
                    :disabled="ghgiStore.item.isSubmitted"
                    name="selfConsumption"
                    v-validate="'required|numeric'"
                    v-model="cbuilding.selfConsumption"
                  ></b-input>
                </b-field>
              </b-notification>
              <b-notification :closable="false">
                <consumption-form
                  :disabled="ghgiStore.item.isSubmitted"
                  v-model="cbuilding.electricity"
                >
                  <template v-slot:monthly>
                    {{ $t('compCarbonFormsBuildingsModal.field-3') }}
                    {{ $t('kwh') }}
                  </template>
                  <template v-slot:total>
                    {{ $t('compCarbonFormsBuildingsModal.field-4') }}
                    {{ $t('kwh') }}
                  </template>
                </consumption-form>
              </b-notification>
            </m-tab-item>
            <m-tab-item icon="snowflake-o" :label="$t('refrigerants')">
              <b-notification :closable="false">
                {{ $t('compCarbonFormsBuildingsModal.info-3') }}
                <b-collapse
                  :open="false"
                  position="is-bottom"
                  aria-id="contentIdForA11y1"
                >
                  <a
                    class="link"
                    slot="trigger"
                    slot-scope="props"
                    aria-controls="contentIdForA11y1"
                  >
                    <b-icon
                      :icon="!props.open ? 'caret-down' : 'caret-up'"
                    ></b-icon>
                    {{
                      !props.open
                        ? $t('compCarbonFormsBuildingsModal.more')
                        : $t('compCarbonFormsBuildingsModal.less')
                    }}
                  </a>
                  {{ $t('compCarbonFormsBuildingsModal.info-4') }}
                </b-collapse>
              </b-notification>
              <table
                class="table is-narrow is-striped is-hoverable has-mobile-cards"
                style="width: 100%"
              >
                <thead>
                  <tr>
                    <th>
                      <div class="th-wrap">
                        {{ $t('compCarbonFormsBuildingsModal.refrigerant') }}
                      </div>
                    </th>
                    <th>
                      <div class="th-wrap">
                        {{ $t('compCarbonFormsBuildingsModal.field-6') }}
                      </div>
                    </th>
                    <th style="width: 60px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="is-empty"
                    v-show="cbuilding.refrigerants.length === 0"
                  >
                    <td colspan="3">
                      <section class="section">
                        <div class="content has-text-grey has-text-centered">
                          <p>
                            <i class="fa fa-ban" style="font-size: 64px"></i>
                          </p>
                          <p>
                            {{
                              $t('compCarbonFormsBuildingsModal.no-refrigerant')
                            }}
                          </p>
                        </div>
                      </section>
                    </td>
                  </tr>
                  <tr
                    v-for="refrigerant in cbuilding.refrigerants"
                    :key="refrigerant.id"
                    draggable="false"
                  >
                    <td class="has-text-center">
                      {{ getRefrigerantDescription(refrigerant.name) }}
                    </td>
                    <td class="has-text-center">
                      {{ refrigerant.total }}
                    </td>
                    <td>
                      <b-button @click="deleteRefrigerant(refrigerant)">
                        <i class="fa fa-trash" style="font-size: 16px"></i>
                      </b-button>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th>
                      <b-select
                        expanded
                        :disabled="ghgiStore.item.isSubmitted"
                        v-model="crefrigerant.name"
                      >
                        <option
                          :value="refrigerant"
                          v-for="(refrigerant, index) in refrigerants"
                          :key="index"
                        >
                          {{ getRefrigerantDescription(refrigerant) }}
                        </option>
                      </b-select>
                    </th>
                    <th>
                      <b-field
                        :type="{
                          'is-danger': errors.has('crefrigerantConsumption')
                        }"
                        :message="errors.first('crefrigerantConsumption')"
                      >
                        <b-input
                          name="crefrigerantConsumption"
                          v-model="crefrigerant.total"
                          :disabled="ghgiStore.item.isSubmitted"
                          v-validate="'required|decimal'"
                        ></b-input>
                      </b-field>
                    </th>
                    <th style="width: 60px">
                      <b-button
                        :disabled="
                          isNaN(crefrigerant.total) ||
                          crefrigerant.total === '' ||
                          ghgiStore.item.isSubmitted
                        "
                        @click="addRefrigerant"
                      >
                        <i class="fa fa-plus" style="font-size: 16px"></i>
                        {{ $t('add') }}
                      </b-button>
                    </th>
                  </tr>
                </tfoot>
              </table>
            </m-tab-item>
            <m-tab-item icon="tint" :label="$t('water')">
              <b-notification :closable="false">
                <consumption-form
                  :disabled="ghgiStore.item.isSubmitted"
                  v-model="cbuilding.water"
                >
                  <template v-slot:monthly>
                    {{ $t('compCarbonFormsBuildingsModal.field-3') }} m3
                  </template>
                  <template v-slot:total>
                    {{ $t('compCarbonFormsBuildingsModal.field-4') }} m3
                  </template>
                </consumption-form>
              </b-notification>
            </m-tab-item>
            <m-tab-item
              v-for="(heating, index) in cbuilding.heatings"
              :key="index"
            >
              <template v-if="index > 0" slot="headerClosable">
                <span class="icon"><i class="fa fa-thermometer-full"></i></span>
                <span class="heating-header">
                  {{ $t('heatings') }} {{ index + 1 }}
                </span>
                <b-tooltip
                  multilined
                  :label="$t('compCarbonFormsBuildingsModal.tooltip-3')"
                  type="is-black"
                >
                  <b-button
                    class="is-white is-small"
                    style="margin-left: 5px"
                    @click="deleteHeatingSystem(heating)"
                  >
                    <b-icon icon="close" size="is-small"></b-icon>
                  </b-button>
                </b-tooltip>
              </template>
              <template
                v-else-if="index === 0 && cbuilding.heatings.length > 1"
                slot="header"
              >
                <span class="icon"><i class="fa fa-thermometer-full"></i></span>
                <span class="heating-header">
                  {{ $t('heatings') }} {{ index + 1 }}
                </span>
              </template>
              <template v-else slot="header">
                <span class="icon"><i class="fa fa-thermometer-full"></i></span>
                <span class="heating-header"> {{ $t('heatings') }} </span>
              </template>
              <b-notification :closable="false">
                <div class="columns">
                  <div class="column is-one-third">
                    <b-field
                      :label="$t('compCarbonFormsBuildingsModal.field-1')"
                      :type="{
                        'is-danger': heatingTypeIsEmpty(
                          cbuilding.heatings[index]
                        )
                      }"
                      :message="{
                        [$t('compCarbonFormsBuildingsModal.missingType')]:
                          heatingTypeIsEmpty(cbuilding.heatings[index])
                      }"
                    >
                      <b-select
                        expanded
                        name="heatings"
                        :disabled="ghgiStore.item.isSubmitted"
                        :placeholder="
                          $t('compCarbonFormsBuildingsModal.field-1')
                        "
                        v-model="cbuilding.heatings[index].type"
                        @input="updateNetwork(index)"
                      >
                        <option
                          :selected="index === 0"
                          :value="heating"
                          v-for="(heating, index) in heatings"
                          :key="index"
                        >
                          {{ $t(heating) }}
                        </option>
                      </b-select>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field
                      :label="$t('compCarbonFormsBuildingsModal.field-2')"
                      :type="{ 'is-danger': errors.has('network') }"
                      :message="errors.first('network')"
                    >
                      <b-autocomplete
                        expanded
                        name="network"
                        v-validate="{
                          required:
                            cbuilding.heatings[index].type === URBAN_NETWORK,
                          isUrbanNetwork: true
                        }"
                        :placeholder="
                          $t('compCarbonFormsBuildingsModal.field-2')
                        "
                        :disabled="
                          cbuilding.heatings[index].type !== URBAN_NETWORK ||
                          ghgiStore.item.isSubmitted
                        "
                        v-model="urbanNetwork[index]"
                        :open-on-focus="true"
                        :data="filteredUrbanNetwork(index)"
                        field="description_FR"
                        @select="
                          (option) =>
                            (cbuilding.heatings[index].urbanNetwork =
                              option.network)
                        "
                        :clearable="true"
                      />
                    </b-field>
                  </div>
                </div>
              </b-notification>
              <b-notification
                v-if="cbuilding.heatings[index].type === 'electric'"
                :closable="false"
              >
                <div v-html="$t('compCarbonFormsBuildingsModal.info-5')" />
              </b-notification>
              <b-notification
                :closable="false"
                v-show="cbuilding.heatings[index].type !== 'electric'"
              >
                <b-checkbox
                  :disabled="ghgiStore.item.isSubmitted"
                  v-model="cbuilding.heatings[index].isOwnedByLab"
                >
                  {{ $t('compCarbonFormsBuildingsModal.check-2') }}
                </b-checkbox>
              </b-notification>
              <b-notification
                :closable="false"
                v-show="cbuilding.heatings[index].type !== 'electric'"
              >
                <consumption-form
                  :disabled="ghgiStore.item.isSubmitted"
                  v-model="cbuilding.heatings[index]"
                >
                  <template v-slot:monthly>
                    {{ $t('compCarbonFormsBuildingsModal.field-3') }}
                    {{ $t(heatingUnit(cbuilding.heatings[index])) }}
                  </template>
                  <template v-slot:total>
                    {{ $t('compCarbonFormsBuildingsModal.field-4') }}
                    {{ $t(heatingUnit(cbuilding.heatings[index])) }}
                  </template>
                </consumption-form>
              </b-notification>
            </m-tab-item>
            <template slot="addTab">
              <b-tooltip
                multilined
                :label="$t('compCarbonFormsBuildingsModal.tooltip-2')"
                type="is-black"
              >
                <button
                  class="button is-white is-small add"
                  type="button"
                  :disabled="ghgiStore.item.isSubmitted"
                  @click="addHeatingSystem"
                >
                  <i class="fa fa-plus" style="font-size: 18px"></i>
                </button>
              </b-tooltip>
            </template>
          </m-tabs>

          <hr />
          <nav class="level">
            <div class="level-left"></div>
            <div class="buttons level-right">
              <b-button class="button" @click="closeForm()" icon-left="close">
                {{ $t('cancel') }}
              </b-button>
              <button
                v-show="modeCreation"
                :disabled="isSubmitted"
                type="submit"
                class="button is-primary"
              >
                <span class="icon is-small"><i class="fa fa-plus"></i></span>
                <span> {{ $t('add') }} </span>
              </button>
              <button
                :disabled="isSubmitted"
                v-show="!modeCreation"
                type="submit"
                class="button is-primary"
              >
                <span class="icon is-small"><i class="fa fa-refresh"></i></span>
                <span> {{ $t('update') }} </span>
              </button>
            </div>
          </nav>
        </section>
      </form>
    </div>
  </b-modal>
</template>

<script>
import Building from '@/models/carbon/Building.js'
import Modules from '@/models/Modules.js'
import { useAdminStore } from '@/stores/admin.js'
import { useGHGIStore } from '@/stores/ghgi.js'
import { useAuthenticationStore } from '@/stores/authentication.js'

import _ from 'lodash'

const DEFAULT_REFRIGERANT = 'nf3'

export default {
  name: 'Modal',
  props: {
    displayModal: {
      type: Boolean,
      default: false
    },
    building: {
      type: Object,
      default: function () {
        return {}
      }
    },
    buildings: {
      type: Array,
      default: function () {
        return []
      }
    },
    modeCreation: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'consumption-form': () =>
      import('@/components/carbon/forms/ConsumptionForm.vue'),
    'm-tabs': () => import('@/components/tabs_custom/Tabs.vue'),
    'm-tab-item': () => import('@/components/tabs_custom/TabItem.vue'),
    'tags-input': () => import('@/components/core/TagsInput.vue'),
    'l-field': () => import('@/components/LField.vue')
  },
  $_veeValidate: {
    validator: 'new'
  },
  setup () {
    const adminStore = useAdminStore()
    const ghgiStore = useGHGIStore()
    const authStore = useAuthenticationStore()
    return { adminStore, ghgiStore, authStore }
  },
  data () {
    return {
      URBAN_NETWORK: Building.urbanNetwork,
      cbuilding: _.cloneDeep(this.building),
      crefrigerant: {
        id: null,
        name: DEFAULT_REFRIGERANT,
        total: 0
      },
      urbanNetwork: [''],
      activeTab: 0
    }
  },
  computed: {
    refrigerants: function () {
      return Building.getRefrigerants()
    },
    urbanNetworks: function () {
      return Building.getUrbanNetworks()
    },
    heatings: function () {
      return Building.getHeatings()
    },
    isSubmitted: function () {
      return this.ghgiStore.item.isSubmitted
    },
    allBuildings: function () {
      let usedName = this.buildings.map((obj) => obj.name)
      return this.adminStore.allBuildings.filter(
        (obj) => !usedName.includes(obj.name)
      )
    },
    modalTitle: function () {
      let title = this.$t('compCarbonFormsBuildingsModal.title-1')
      if (this.modeCreation) {
        title = this.$t('compCarbonFormsBuildingsModal.title-2')
      } else if (this.isSubmitted) {
        title = this.$t('compCarbonFormsBuildingsModal.title-3')
      }
      return title
    }
  },
  methods: {
    heatingUnit (heatingSystem) {
      let unit = 'kwh.lhv'
      if (
        heatingSystem.type !== null &&
        heatingSystem.type !== this.URBAN_NETWORK &&
        heatingSystem.type !== 'electric'
      ) {
        unit = Building.getHeatingUnit(heatingSystem.type)
      }
      return unit
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.modeCreation) {
            this.$emit('add', this.cbuilding)
          } else {
            this.$emit('update', {
              from: this.building,
              to: this.cbuilding
            })
          }
        }
      })
    },
    updateNetwork (i) {
      if (this.cbuilding.heatings[i].type !== this.URBAN_NETWORK) {
        this.cbuilding.heatings[i].urbanNetwork = null
        this.urbanNetwork[i] = ''
      }
    },
    filteredUrbanNetwork (i) {
      return this.urbanNetworks.filter((option) => {
        return (
          option.description_FR
            .toString()
            .toLowerCase()
            .indexOf(this.urbanNetwork[i].toLowerCase()) >= 0
        )
      })
    },
    getRefrigerantDescription (type) {
      return Building.getDescription(Modules.REFRIGERANTS, type)
    },
    selectBuilding (building) {
      this.cbuilding.id = building.id
      this.cbuilding.name = building.name
      this.cbuilding.selfProduction = building.selfProduction
      this.cbuilding.area = building.area
      this.cbuilding.share = building.share
      this.cbuilding.constructionYear = building.constructionYear
    },
    reset () {
      this.cbuilding.id = null
      this.cbuilding.name = ''
      this.cbuilding.selfProduction = false
      this.cbuilding.area = 0
      this.cbuilding.share = 100
    },
    closeForm: function () {
      this.$emit('close')
    },
    addRefrigerant: function () {
      this.cbuilding.refrigerants.push({
        id: this.crefrigerant.id,
        name: this.crefrigerant.name,
        total: this.crefrigerant.total
      })
      this.crefrigerant.name = DEFAULT_REFRIGERANT
      this.crefrigerant.total = 0
    },
    deleteRefrigerant: function (gas) {
      let index = null
      if (gas.id === null) {
        index = this.cbuilding.refrigerants.findIndex(
          (obj) => obj.name === gas.name
        )
      } else {
        index = this.cbuilding.refrigerants.findIndex(
          (obj) => obj.id === gas.id
        )
      }
      this.cbuilding.refrigerants.splice(index, 1)
    },
    addHeatingSystem: function () {
      this.cbuilding.heatings.push(Building.createHeating())
      this.urbanNetwork.push('')
      // this.activeTab = this.cbuilding.heatings.length +1
      setTimeout(() => {
        this.activeTab = this.cbuilding.heatings.length + 1
      }, 200)
    },
    deleteHeatingSystem: function (heating) {
      let index = null
      if (heating.id === null) {
        index = this.cbuilding.heatings.findIndex(
          (obj) => obj.type === heating.type
        )
      } else {
        index = this.cbuilding.heatings.findIndex(
          (obj) => obj.id === heating.id
        )
      }
      this.cbuilding.heatings.splice(index, 1)
      this.activeTab = 0
    },
    heatingTypeIsEmpty: function (heating) {
      const typeIsEmpty =
        this.building.getHeatingConsumption(heating) !== 0 && !heating.type
      return typeIsEmpty
    }
  },
  created () {
    let self = this
    this.$validator.extend('uniqueID', {
      getMessage: (field) => self.$t('compCarbonFormsBuildingsModal.error-1'),
      validate: (value) => {
        if (!this.modeCreation) {
          if (value === this.cbuilding.name) {
            return true
          } else {
            return (
              this.buildings.filter((obj) => obj.name === value).length === 0
            )
          }
        } else {
          return this.buildings.filter((obj) => obj.name === value).length === 0
        }
      }
    })
    this.$validator.extend('isUrbanNetwork', {
      getMessage: (field) => self.$t('compCarbonFormsBuildingsModal.error-2'),
      validate: (value) => {
        return this.urbanNetworks
          .map((obj) => obj.description_FR)
          .includes(value)
      }
    })
    if (!this.modeCreation) {
      this.building.heatings.forEach(function (heating, i) {
        self.urbanNetwork[i] = self.urbanNetworks.filter(
          (obj) => obj.network === heating.urbanNetwork
        )
        if (self.urbanNetwork[i].length > 0) {
          self.urbanNetwork[i] = self.urbanNetwork[i][0].description_FR
        } else {
          self.urbanNetwork[i] = ''
        }
      })
    }
  }
}
</script>
<style>
.add-button {
  margin-left: 10px;
  padding-bottom: 3px;
}
</style>
